<template>
    <admin-layout class="tenants">

        <app-content-pane class="ml-3">

            <template #title>
                <div class="px-4 pt-3">
                    <h1>Tenants</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item active">Tenants</li>
                        </ol>
                    </nav>
                </div>
                <hr class="mb-0">
                <div class="actions px-4 pt-3">
                    <div class="form-group flex-grow-1 mr-2">
                        <input type="text"
                               v-model="filters.q"
                               class="form-control"
                               @keyup="searchDebounced()"
                               placeholder="Search Projects">
                    </div>
                    <div class="form-group">
                        <inertia-link :href="route('tenant.create', {...global_url_params})"
                                      class="btn btn-primary d-flex align-items-center">
                            <img src="/images/logos/plus-circle-solid-light.svg" class="mr-1" alt="">
                            + New Tenant
                        </inertia-link>
                    </div>
                </div>
            </template>

            <hr class="my-0">

            <section class="px-3 pb-4">

                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                        <tr>
                            <th class="border-0" width="120"></th>
                            <th class="border-0">Tenant</th>
                            <th class="border-0 text-right" width="200">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="tenant in tenants.data" :key="tenant.id">
                            <td>
                                <inertia-link :href="route('tenant.edit', {tenant: tenant.id, ...global_url_params})">
                                    <img class="img-fluid" :src="logo(tenant)" alt="">
                                </inertia-link>
                            </td>
                            <td>
                                <inertia-link :href="route('tenant.edit', {tenant: tenant.id, ...global_url_params})">
                                    <strong>
                                        {{ tenant.name }}
                                    </strong>
                                </inertia-link>

                                <br>

                                <a :href="url(tenant)" target="_blank">
                                    {{ url(tenant) }}
                                </a>

                            </td>
                            <td class="text-right">
                                <button type="button"
                                        :disabled="is_busy"
                                        class="btn btn-danger"
                                        @click="remove( tenant )">Delete</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <pagination :links="tenants.links"/>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AppContentPane from "@/Components/AppContentPane";
import AdminLayout from "@/Layouts/AdminLayout";
import {uploads} from "@/mixins/uploads";
export default {
    name: "Index",
    components: {AdminLayout, AppContentPane},
    props: ['tenants'],

    data(){
        return {

            is_busy: false,

            filters: {
                q: '',
            },

            searchDebounced: _.debounce(() => {
                this.$inertia.replace(route(route().current(), {...route().params, ...this.filters}));
            }, 750),
        }
    },


    computed: {

    },


    methods: {
        logo(tenant){
            if( !tenant?.meta?.logo?.url ) return '/images/dfc-logo.svg';
            return uploads.image( tenant.meta.logo.url, {w: 100, h:100, c: false} );
        },

        url(tenant){
            return `/${tenant.handle}/`;
        }
    },


    mounted() {
        this.filters = { ...this.filters, ...this.route().params };
        this.setTitle( 'Tenants' );
    }

}
</script>

<style lang="scss" scoped>
.actions{
    display: flex;
}
</style>
